import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AlertController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Api } from '../../../smoothr-web-app-core/api/api';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { environment } from '../../../environments/environment';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { getPrice, numberD, numberToCurrency, sleep } from '../../../smoothr-web-app-core/utils/utils';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { NavigationService } from '../../services/navigation.service';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import Order from 'src/smoothr-web-app-core/models/Order';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import Article from 'src/smoothr-web-app-core/models/Article';

@Component({
	selector: 'app-payment-success',
	templateUrl: './payment-success.page.html',
	styleUrls: ['payment-success.page.scss'],
})
export class PaymentSuccessPage extends RepositoryDirective implements OnInit {
	static url = 'payment/success';
	static urlWithPaymentParam = 'payment/success/:payment';
	static ORDER_ID_PARAM = 'order';
	moment = moment;
	OrderUtils = OrderUtils;
	pt = PreorderType;
	orderVenue: Venue;
	error: any;
	orderId: string;
	environment = environment;
	numberToCurrency = numberToCurrency;
	loading = true;
	numberD = numberD;
	savedOrder: Order;
	constructor(
		private translate: TranslateService,
		protected repository: RepositoryService,
		private alertCtrl: AlertController,
		private router: Router,
		private snackbarCtrl: MatSnackBar,
		private route: ActivatedRoute,
		private analytics: AnalyticsService,
		private navigationService: NavigationService
	) {
		super(repository);
	}

	// static async navigate(router: Router, order: string, payment: string) {
	// 	await router.navigate([this.url + '/' + payment], {
	// 		queryParams: {
	// 			order
	// 		}
	// 	});
	// }

	ionViewDidEnter() {
		console.log(this.verifiedOrder);
		this.repository.onOrderChange(null);
	}

	async onInitFinish() {
		super.onInitFinish();
		this.route.queryParams.subscribe(params => {
			console.log({
				params,
			});
			if (this.verifiedOrder && this.verifiedOrder._id && !params.order) {
				this.orderId = this.verifiedOrder._id;
			} else {
				this.orderId = params.order;
			}
			this.reloadOrder();
		});
	}

	async reloadOrder(attempt: number = 0, error = null) {
		this.error = null;
		this.loading = true;
		if (attempt > 10) {
			this.error = error ? error : this.translate.instant('payment_success_page.payment_error');
			this.snackbarCtrl.open(error, null, {
				duration: 2000,
			});
			this.loading = false;
			return;
		}
		this.repository.saveSanifairScanData$.next([]);
		if (attempt > 0) {
			await sleep(200);
		}
		try {
			const orderResponse = await Api.getOrder(this.orderId);
			this.savedOrder = orderResponse.data;
			this.repository.verifiedOrder.emit(orderResponse.data);
			if (!this.verifiedOrder.isPayed) {
				await this.reloadOrder(attempt + 1, this.translate.instant('payment_success_page.please_reload'));
				return;
			}
			if (!this.customer.isAnonymous) {
				try {
					this.repository.reloadCustomer();
				} catch (e) {
					console.log('Can not load user');
				}
			}
			this.analytics.paymentSuccess();
			try {
				if (this.venue && this.venue._id === this.verifiedOrder.venue) {
					this.orderVenue = this.venue;
				} else {
					this.orderVenue = (await Api.getLazyVenue(this.verifiedOrder.venue)).data;
				}
				this.error = false;
				this.loading = false;
			} catch (e) {
				console.error(e);
				await this.reloadOrder(attempt + 1, error ? error : e);
				return;
			}
		} catch (e) {
			console.error(e);
			await this.reloadOrder(attempt + 1, e);
			return;
		}
	}

	async toMenu() {
		if (this.loading) {
			return;
		}
		if (this.error) {
			this.reloadOrder();
			return;
		}
		this.loading = true;

		try {
			await this.repository.cleanRepository();
			this.repository.getVenue(this.orderVenue._id);
			await sleep(300);
			this.repository.createOrder(this.orderVenue, null, OrderType.PREORDER, this.savedOrder.preorder.type, null);
			await sleep(500);
			this.navigationService.menu();
		} catch (error) {
			this.navigationService.home();
		}
	}
	checkArticleTagEmpty(event: any) {
		// console.log(event);
		if (event.article.tags?.length > 0) {
			return event.article.tags.some(it => it === 'empty');
		} else {
			return false;
		}
	}

	checkArticleTagColdWaterAndZero(event: any) {
		// console.log(event);
		if (event.article.tags?.length > 0) {
			return event.article.tags.some(it => it === 'filter_cold_drink') && numberD(event.article.price) === 0;
		} else {
			return false;
		}
	}
	priceOfOption(articleGroup: ArticleGroup, articleOption: ArticleOption): number {
		const price = getPrice(articleOption.article, OrderType.PREORDER, this.order.preorder.type);
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && articleGroup.isPromo) {
			return 0;
		}
		return price;
	}

	checkName(article: any) {
		return article && article?.tags?.includes('is_deposit');
	}
	checkIfArticleSanifair(article: any) {
		return article && article?.tags?.length > 0 && article?.tags?.includes('sanifair_voucher');
	}
	articlePrice(articleGroup: ArticleGroup, isVerifiedArticle: boolean = false): number {
		if (articleGroup.article) {
			if (articleGroup.article?.tags?.find(it => it?.identifier === 'sanifair_voucher')) {
				return -OrderUtils.articleGroupsTotalPrice([articleGroup], OrderType.PREORDER, this.order?.preorder?.type);
			}
			return numberD(articleGroup.article.price) * articleGroup.quantity;
		} else {
			return 0;
		}
	}
	articleTotalPrice(articleGroup: ArticleGroup): number {
		if (articleGroup) {
			if ((articleGroup?.article?.tags as any[])?.includes('sanifair_voucher')) {
				return numberD(articleGroup?.totalPrice) ?? 0;
			}
			return OrderUtils.articleGroupsTotalPrice([articleGroup], OrderType.PREORDER, this.order?.preorder?.type);
		} else {
			return 0;
		}
	}

	mergeDuplicateArticles(options: ArticleOption[]) {
		const mergedMap = new Map<string, any>();

		for (const option of options) {
			const key = JSON.stringify({
				articleId: option.article._id,
				group: option.group,
				dependsOn: option.dependsOn,
				dependency: option.dependency,
			});

			if (mergedMap.has(key)) {
				const existing = mergedMap.get(key);
				existing.quantity += option.quantity;
			} else {
				mergedMap.set(key, { ...option });
			}
		}

		return Array.from(mergedMap.values());
	}
	public checkIfHasReplaceMainArticle(articleGroup: ArticleGroup) {
		let obj: {
			replaceOptionGroup: any;
			replaceArticleName: boolean;
			replaceArticleValue: Article;
		} | null = null;
		if (articleGroup?.groups) {
			console.log(articleGroup.groups);
			const listSelectedGroups = new Map(articleGroup.groups.map((it: any) => [it.group, it]));

			articleGroup.groups.forEach((group: any) => {
				console.log(articleGroup.article.name.de, group, listSelectedGroups, listSelectedGroups.has(group._id));
				if (listSelectedGroups.has(group.group)) {
					if (group && (group?.tags ?? []) && (group.tags ?? []).find((it: any) => it === 'replaces_main_article')) {
						obj = {
							replaceOptionGroup: group,
							replaceArticleName: true,
							replaceArticleValue: listSelectedGroups.get(group.group)?.article,
						};
					}
				}
			});
		}
		if (obj) {
			console.log(obj);
		}
		return obj;
	}
	public calculateDublePrice(articleGroup: ArticleGroup, replaceOptionGroup: any) {
		let copyOfGroup = JSON.parse(JSON.stringify(articleGroup));
		copyOfGroup.groups = copyOfGroup.groups.filter(it => it.group === replaceOptionGroup?.group);
		return OrderUtils.totalPrice(copyOfGroup, this.verifiedOrder.type, this.verifiedOrder.preorder.type);
	}
}
